import React from "react";
import MarkdownRenderer from "./MarkdownRenderer";
import MessageToolbar from "./MessageToolbar";

export default function AssistantMessage({
  content = "",
  timestamp,
  children,
}) {
  const time = timestamp
    ? new Date(timestamp).toLocaleTimeString([], {
        hour: "2-digit",
        minute: "2-digit",
      })
    : "";

  return (
    <div
      style={{
        display: "flex",
        justifyContent: "flex-start",
        marginBottom: 24,
      }}
    >
      <div
        style={{
          width: "100%",
          maxWidth: 760,
          background: "#ffffff",
          border: "1px solid #e5e7eb",
          borderRadius: 16,
          padding: 20,
          boxShadow: "0 2px 8px rgba(0,0,0,0.05)",
        }}
      >
        <div
          style={{
            display: "flex",
            justifyContent: "space-between",
            alignItems: "center",
            marginBottom: 12,
          }}
        >
          <strong style={{ color: "#0f766e" }}>
            Ecovanta Copilot
          </strong>

          <small style={{ color: "#6b7280" }}>
            {time}
          </small>
        </div>

        <MarkdownRenderer>
          {content}
        </MarkdownRenderer>

     <MessageToolbar
  onCopy={() => navigator.clipboard.writeText(content)}
  onRegenerate={() => console.log("Regenerate")}
  onLike={() => console.log("Like")}
  onDislike={() => console.log("Dislike")}
/>

{children && (
  <div style={{ marginTop: 16 }}>
    {children}
  </div>
)}
      </div>
    </div>
  );
}